module.exports = __webpack_public_path__ + "static/img/14000775.4bcb3941.png";